import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import useTranslations from "hooks/useTranslations"
import Empower from "images/pro/empower.svg"
import EmployerImage from "images/pro/employer-image.svg"
import Balance from "images/pro/balance.svg"
import Safety from "images/pro/safety.svg"
import Productivity from "images/pro/productivity.svg"
import ConflictManagement from "images/pro/conflict-management.svg"
import DisclosureList from "components/organisms/common/DisclosureList"

const ImpactImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      desktopImage: file(relativePath: { eq: "pro/impact.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 600)
        }
      }
      mobileImage: file(relativePath: { eq: "pro/impact.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 400, layout: CONSTRAINED)
        }
      }
    }
  `)

  const sources = withArtDirection(getImage(images.mobileImage), [
    {
      image: getImage(images.desktopImage),
      media: "(min-width: 1024px)",
    },
  ])
  return (
    <GatsbyImage
      image={getImage(sources)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "top",
      }}
      className={className}
    />
  )
}

export default function ImpactPro() {
  const {
    impactTitle,
    impact1Title,
    impact1Description,
    impact2Title,
    impact2Description,
    impact3Title,
    impact3Description,
    impact4Title,
    impact4Description,
    impact5Title,
    impact5Description,
    impact6Title,
    impact6Description,
  } = useTranslations()

  const features = [
    {
      name: impact1Title,
      description: impact1Description,
      icon: Safety,
    },
    {
      name: impact3Title,
      description: impact3Description,
      icon: Balance,
    },
    {
      name: impact4Title,
      description: impact4Description,
      icon: ConflictManagement,
    },
    {
      name: impact5Title,
      description: impact5Description,
      icon: Productivity,
    },
    {
      name: impact6Title,
      description: impact6Description,
      icon: EmployerImage,
    },
    {
      name: impact2Title,
      description: impact2Description,
      icon: Empower,
    },
  ]
  return (
    <DisclosureList title={impactTitle} list={features} Image={ImpactImage} />
  )
}
